import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1>Découverte des Mathématiques Africaines</h1>
    </header>
  );
};

export default Header;